import { render, staticRenderFns } from "./HomePhone.vue?vue&type=template&id=2fe7be82&scoped=true&"
import script from "./HomePhone.vue?vue&type=script&lang=js&"
export * from "./HomePhone.vue?vue&type=script&lang=js&"
import style0 from "./HomePhone.vue?vue&type=style&index=0&id=2fe7be82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe7be82",
  null
  
)

export default component.exports